import React from 'react';
import { useParams } from 'react-router-dom';
import POSPage from './POSPage';

interface POSProps {
  mode?: 'TABLE' | 'TAKEAWAY';
}

export function POS({ mode: propMode }: POSProps) {
  const { mode: urlMode } = useParams<{ mode?: string }>();
  
  // Decidimos el modo: si viene por prop lo usamos, si no, miramos la URL
  let finalMode: 'TABLE' | 'TAKEAWAY' = propMode || 'TABLE';
  if (!propMode && urlMode?.toLowerCase() === 'takeaway') {
    finalMode = 'TAKEAWAY';
  }

  return <POSPage mode={finalMode} />;
}

export default POS;
